// extracted by mini-css-extract-plugin
export default {"content-wrapper":"OneTimePasswordDetails_content-wrapper__6phL5","content":"OneTimePasswordDetails_content__QZkU-","no-img":"OneTimePasswordDetails_no-img__tycOk"};